import PropTypes from 'prop-types';
import { CART_PAGE } from '../../constants/global';
import { useEffect, useState } from 'react';

const BreadPayPlacement = ({ type, productIndex }) => {
  const breadButtonId =
    type === CART_PAGE ? 'bread-cart-btn' : `bread-product-btn${productIndex ? `-${productIndex}` : ''}`;
  const [hasContent, setHasContent] = useState(false);

  const checkDivContent = () => {
    const div = document.getElementById(breadButtonId);
    if (div) {
      setHasContent(div.innerHTML.trim().length > 0);
    }
  };

  useEffect(() => {
    // Initial check
    checkDivContent();

    // Create an observer to monitor changes in the div's content
    const observer = new MutationObserver(() => {
      checkDivContent();
    });

    const targetNode = document.getElementById(breadButtonId);
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, [breadButtonId]);

  const handleLearnMoreClick = () => {
    const firstDiv = document.querySelector('.bread-placements-section > div > div ');
    const anchor = firstDiv.querySelector('a');
    anchor.click();
  };
  return (
    <div className="bread-placements-section">
      <div id={breadButtonId}></div>
      {hasContent && <p onClick={handleLearnMoreClick}>Learn More</p>}
    </div>
  );
};

export default BreadPayPlacement;

BreadPayPlacement.propTypes = {
  isInitialized: PropTypes.bool,
  type: PropTypes.string,
  productIndex: PropTypes.number
};
